<template>
    <div class="bgg bgg-top">

        <header>
          <div class="hyper-link">
            <a href="#search"  class="btn btn-lg shadow b-green1 font-blue">Buscar EmpleoSS</a>
            <a href="/perfil/empleos" class="btn btn-lg shadow b-green1 font-blue">¿Reclutando?</a>
          </div>

          <div>
            <img v-responsive.xl.lg  src="@/assets/@banners/@responsive/search-empleos/banner-empleo-interior-1680x1050.jpg" alt="" class="w-100 _img">
            <img v-responsive.md  src="@/assets/@banners/@responsive/search-empleos/banner-empleo-interior-1024x768.jpg" alt="" class="w-100 _img">
            <img v-responsive.sm  src="@/assets/@banners/@responsive/search-empleos/banner-empleo-interior-768x1024.jpg" alt="" class="w-100 _img">
            <img v-responsive.xs  src="@/assets/@banners/@responsive/search-empleos/banner-empleo-interno-500x750.jpg" alt="" class="w-100 _img">
          </div>
        </header>

        <section style="background-color: #42409e; border-top: 2px solid #8222f5" id="search">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <b-form @submit="searchJob">
                                <h1 class="font-weight-bold pt-5 text-white">¡Busca tu oportunidad!</h1>
                                <div class="__controls-head d-flex mt-4">
                                    <b-form-input type="text"  class="border-0 shadow-sm p-4" v-model="search" placeholder="¿Qué tipo de empleo buscas?" autocomplete="off"></b-form-input>
                                    <b-button type="submit" class="btn b-orange ml-2 shadow-lg" :disabled="loading.search">
                                        <b-spinner v-if="loading.search" small label="Espere ..."></b-spinner>
                                        <i class="fas fa-search" v-show="!loading.search"></i>
                                    </b-button>
                                </div>

                                <!-- Ocultar opciones azavada -->
                                <div class="__controls-filter mt-2 d-lg-flex font-gray-dark" v-if="advanceFilter">
                                    <b-form-group label="Ciudad, Estado, País" class="col-lg-4 p-1 col-md-12 col-sm-12">
                                        <b-form-input type="text"  class="border-0" v-model="advanseSearch.city" placeholder="Ej. Guadalajara" autocomplete="off"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="Sueldo" class="col-lg-4 p-1 col-md-12 col-sm-12">
                                        <b-form-input type="text"  class="border-0" v-model="advanseSearch.payment" placeholder="Ej. 5000" autocomplete="off"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="Tipo de empleo" class="col-lg-4 p-1 col-md-12 col-sm-12">
                                        <b-form-select class="border-0"  v-model="advanseSearch.type" :options="tipos_empleo"></b-form-select>
                                    </b-form-group>
                                </div>
                                <button type="button" class="btn b-white mt-3 shadow-sm" @click="advanceFilter = !advanceFilter"><i class="fas fa-cog"></i> {{advanceFilter ? 'Ocultar Filtro' : 'Filtrar'}}</button>
                                <div class="font-weight-light py-2 text-white">Encuentra empresas que se ajusten a tus habilidades</div>
                        </b-form>
                    </div>
                </div>
            </div>
        </section>
        <section class="b-white shadow-sm" v-if="!isLoggedIn">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 py-4">
                        ¿Quieres formar parte de nuestras empresas registradas? puedes <router-link to="/registrar" class="font-orange">registrarte</router-link> de forma gratuita.
                    </div>
                </div>
            </div>
        </section>
        <section class="my-2" v-if="jobs.length > 0">
            <div class="container py-3">
                <div class="row">
                    <div class="col-lg-12 d-flex flex-wrap justify-content-between">
                        <JobMini v-for="job in jobs" :key="job.id" :id="job.id"
                            :url_public="job.url_public"
                            :title="job.titulo"
                            :location="job.ubicacion"
                            :type="job.tipo_empleo"
                            :enterprise="job.enterprise"
                            :data="job"
                        />
                    </div>
                </div>
            </div>
        </section>
        <div v-else class="row py-5">
          <div class="col-lg-12 text-center font-gray-dark">
            <h1 class="font-weight-bold">¡Ups!</h1>
            <h5>No se han encontrado empleos</h5>
          </div>
        </div>

        <!--Recomendations-->
        <section class="b-gray-light" v-if="jobsRecomendation && jobsRecomendation.total > 0">
            <div class="row">
                <div class="col-lg-12 text-center py-2 b-blue shadow">
                    <h5 class="fas fa-star font-yellow"></h5>
                    <h4>Empleos recomendados para tu perfil</h4>
                </div>
                <div class="container">
                    <div class="col-lg-12 d-flex flex-wrap justify-content-between">
                        <JobMini v-for="job in jobsRecomendation.data" :key="job.id" :id="job.id" :title="job.titulo" :location="job.ubicacion" :type="job.tipo_empleo" :url_public="job.url_public" :enterprise="job.enterprise" :link_enterprise="job.enterprise.url_public"/>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<style lang="scss" scoped>
  @media only screen and (min-width : 1600px) {
    ._img {
      height: 100vh;
    }
  }
  @media only screen and (max-width : 1300px) {
    ._img {
      height: auto;
    }
  }
</style>
<style lang="scss" scoped>
  .hyper-link{
    position: absolute;
    @media only screen and (max-width : 543px){
      margin-top: 65vw;
      text-align: center;
      padding: 10px 0 10px 0px;
      a{
        font-size: 2.6vw;
      }
    }
    @media only screen and (min-width : 544px){
      margin-top: 60vw;
      text-align: center;
      a{
        font-size: 2.5vw
      }
    }
    @media only screen and (min-width : 768px){
      margin-top: 38vw;
      text-align: right;
      a{
        font-size: 1.6vw;
        margin: 0 10px 0 10px;
      }
      padding: 9px 10vw 9px 6vw;
    }
    @media only screen and (min-width : 1000px){
      margin-top: 32vw;
      text-align: right;
      a{
        font-size: 1.3vw;
        margin: 0 10px 0 10px;
      }
      padding: 9px 10vw 9px 6vw;
    }
    width: 100%;

  }
</style>
<script>
import JobMini from './components/home/JobMin'
export default {
    components:{
        'JobMini': JobMini
    },
    data() {
        return {
            loading:{
                search: false,
                jobs: false,
            },
            tipos_empleo: [{ text: 'Selecciona una opción', value: '' }, 'Tiempo Completo', 'Medio Tiempo', 'HomeOffice', 'Temporal'],
            search: '',
            advanceFilter: false,
            advanseSearch: {
                city: '',
                payment: '',
                type: ''
            },
            jobs: [],
            jobsRecomendation: []
        }
    },
    watch:{
        advanceFilter(val){
            if(!val){ //ClearData on FalseAdvanceFilter
                this.advanseSearch.city = ''
                this.advanseSearch.payment = ''
                this.advanseSearch.type = ''
            }
        }
    },
    computed: {
        typeOrigin: function(){ return this.$store.getters.typeOrigin },
        isLoggedIn: function(){ return this.$store.getters.isLoggedIn }
    },
    methods:{
        searchJob(evt){
            evt.preventDefault();
            this.loading.search = true
            // this.api.get('enterprise/job/filter/'+ this.search + '/' + this.advanseSearch.city + '/' + this.advanseSearch.payment + '/' + this.advanseSearch.type ).then(({data}) => {
            this.api.get('enterprise/job/search/filter?job=' + this.search + '&city=' + this.advanseSearch.city + '&payment=' + this.advanseSearch.payment + '&type=' + this.advanseSearch.type ).then(({data}) => {
                this.loading.search = false
                this.jobs = data.data
            }).catch(err => {
                this.loading.search = false
                console.log(err)
            })
        },
        recomendations(){
            this.api.get('student/cv/profile/recomendations/true/20').then(({data}) => {
                this.jobsRecomendation = data.jobs
            })
        },
    },
    created() {
        if(this.typeOrigin == 'student'){
            this.recomendations()
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/#public/job/JobsHome.vue